<template>
    <div>
        <layout-header></layout-header>
        <div v-if="showspinner">
            <loader></loader>
        </div>
        <div v-else>
            <section class="section section-specialities category-section" v-if="!selected_category">
                <div class="container" v-if="categories.length">
                    <div class="section-header text-center">
                        <h2>Explore Medical Specialities</h2>
                        <h3>Connect with Doctors tailored to your needs.</h3>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col">
                            <slick class="specialities-slider slider addcursor" ref="slick" :options="catslickOptions"
                                v-if="categories.length">
                                <div class="speicality-item text-center" :class="{ active: activeCatitem === index }"
                                    v-for="(item, index) in categories" :key="index"
                                    @click="activeCatImage(index, item.category)">
                                    <div class="speicality-img">
                                        <img :src="'https://develop-physio.kneexpert.in' + item.image" class="img-fluid"
                                            height="90px" width="90px" alt="Speciality" />
                                    </div>
                                    <p style="font-size: 18px; margin-bottom: 5px;">
                                        {{ item.category }}
                                    </p>
                                    <p style="font-size: 18px; margin-top: 5px;">
                                        {{ item.category_hindi }}
                                    </p>
                                </div>
                            </slick>
                        </div>
                    </div>
                </div>
            </section>
            <section v-if="hideactiveSubCat">
                <div class="container" v-if="sub_categories.length">
                    <div class="section-header text-center">
                        <h2>Finalize Your Selection</h2>
                        <h3 class="mt-2" style="font-size: 20px; font-weight: bold;">
                            Choose a specific doctor type, <br />
                            whether a physician, cardiologist, or other specialist.
                        </h3>
                    </div>
                    <div class="mt-5">
                        <div class="row justify-content-center">
                            <b-card v-for="item in sub_categories" :key="item.sub_category_name"
                                :class="{ active: activeSubCat === item.sub_category_name }"
                                class="col-12 col-md-4 col-lg-3 col-xl-3" style="border: none;">
                                <!-- Header with explicit styles -->
                                <div class="card" style="border: 1px solid #d3d3d3; height: auto;">
                                    <div
                                        style="background-color: #d3d3d3; color: #000; text-align: center; padding: 1px; font-weight: bold;">
                                        <div>{{ item.sub_category_name }}</div>
                                        <div style="font-size: 14px; margin-top: 5px;">
                                            {{ item.sub_category_hindi }}
                                        </div>
                                    </div>
                                    <div class="card-image" style="border: 1px solid #d3d3d3;">
                                        <img :src="'https://develop-physio.kneexpert.in' + item.image" alt="Specialty"
                                            style="object-fit: cover; margin: 0; padding: 0; width: 100%;"
                                            @click="activeSubImage(item.sub_category_name)" />
                                    </div>
                                    <button class="btn mt-2" @click="toggleDescription(item.sub_category_name)"
                                        style="background-color:rgba(211,211,211,1);">
                                        {{ showDescription[item.sub_category_name] ? "Hide Description" : "Show Description"
                                        }}
                                    </button>
                                    <b-card-text class="mt-2" style="margin: 0; padding: 5px;"
                                        v-if="showDescription[item.sub_category_name]">
                                        {{ item.description }}
                                    </b-card-text>
                                </div>
                            </b-card>
                        </div>
                    </div>
                </div>
            </section>
            <!-- <section v-if="hideactiveSubCat">
                <div class="container" style="width: 92%;" v-if="sub_categories.length">
                    <div class="section-header text-center">
                        <h2>Finalize Your Selection</h2>
                        <h3 class="mt-2" style="font-size: 20px; font-weight: bold;">Choose a specific doctor type, <br>
                            whether a physician, cardiologist, or other specialist.</h3>
                    </div>
                    <div class="mt-5 d-flex justify-content-center">
                        <b-card-group deck>
                            <b-card v-for="item in sub_categories" :key="item.sub_category_name"
                                :class="{ active: activeSubCat === item.sub_category_name }"
                                style="border: none; margin: -11px; width: 450px;">
                           
                                <div class="card" style="border: 1px solid #d3d3d3; margin: 0; height:auto;">
                                    <div
                                        style="background-color: #d3d3d3; color: #000; text-align: center; padding: 1px; font-weight: bold;">
                                        <div>{{ item.sub_category_name }}</div>
                                        <div style="font-size: 14px; margin-top: 5px;">{{ item.sub_category_hindi }}</div>
                                    </div>
                                    <div class="card-image" style="border: 1px solid #d3d3d3;">
                                        <img :src="'https://develop-physio.kneexpert.in' + item.image" alt="Specialty"
                                            style="object-fit: cover; margin: 0; padding: 0; width: 100%;"
                                            @click="activeSubImage(item.sub_category_name)" />
                                    </div>
                                    <button class="btn mt-2" @click="toggleDescription(item.sub_category_name)"
                                        style="background-color:rgba(211,211,211,1);">
                                        {{ showDescription[item.sub_category_name] ? 'Hide Description' : 'Show Description'
                                        }}
                                    </button>
                                    <b-card-text class="mt-2" style="margin: 0; padding: 5px;"
                                        v-if="showDescription[item.sub_category_name]">
                                        {{ item.description }}
                                    </b-card-text>
                                </div>
                            </b-card>
                        </b-card-group>
                    </div>
                </div>
            </section> -->
            <div class="main-wrapper">
                <div class="content">
                    <div class="container">
                        <div class="row" style="display:flex;justify-content: center;">
                            <div class="col-md-6 col-lg-4 col-xl-4 theiaStickySidebar" v-if="!hideactiveSubCat">
                                <div class="main-wrapper">
                                    <div class="card search-filter">
                                        <div class="card-header">
                                            <h4 class="card-title mb-0"
                                                style="font-weight: bold; text-align: left; font-size: 24px;">
                                                Refine Your Search
                                            </h4>
                                        </div>
                                        <div class="card-body">
                                            <div class="filter-widget" style="display: none;">
                                                <h4>Disease, Complaint or Symptoms</h4>
                                                <v-select name="complaints" required="" disabled label="complaints"
                                                    :clearable="false" placeholder="select Complains"
                                                    v-model="selected_complaint">
                                                </v-select>
                                            </div>
                                            <div class="filter-widget" style="text-align: left;">
                                                <h4 style="font-weight: bold; font-size: 18px;">
                                                    Medical Specialities
                                                </h4>
                                                <v-select name="category" required="" label="category" :clearable="false"
                                                    placeholder="select category" v-model="selected_category"
                                                    :reduce="(option) => option.category" :options="categories"
                                                    @input="get_sub_categories()">
                                                </v-select>
                                            </div>
                                            <div class="filter-widget" style="text-align: left;">
                                                <h4 style="font-weight: bold; font-size: 18px;">
                                                    Doctor Type
                                                </h4>

                                                <v-select name="sub-category" required="" label="sub_category_name"
                                                    :clearable="false" placeholder="select sub category"
                                                    v-model="activeSubCat" :reduce="(option) => option.sub_category_name"
                                                    :options="sub_categories">
                                                </v-select>
                                            </div>
                                            <div class="filter-widget" style="display: none;">
                                                <h4>Select Speciality</h4>
                                                <v-select name="speciality" required="" label="speciality"
                                                    :clearable="false" placeholder="select speciality"
                                                    :reduce="(option) => option.speciality" v-model="selected_speciality"
                                                    :options="speciality">
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-12 col-xl-12">
                                <div id="doctors_container" class="doctors_container">
                                    <!-- {{ doctors }} -->
                                    <div class="row justify-content-center m-2">
                                        <div class="card m-2" style="width: 380px;" v-for="(item, index) in doctors"
                                            v-bind:key="index" v-show="setPaginate(index)">
                                            <div class="card-body">
                                                <div class="doctor-action" style="float: right;">
                                                    <a v-if="user_type === 'patient'" href="javascript:void(0)"
                                                        @click="add_favourite_Doctor(item.name)"
                                                        class="btn btn-white fav-btn mb-2"><i class="fas fa-heart"></i></a>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <router-link :to="{
                                                            name: 'doctor-profile',
                                                            params: { name: item.name },
                                                        }">
                                                            <img :src="loadDocImg(item.image)" class="img-fluid"
                                                                alt="User Image"
                                                                style="height: 80px; width: 80px; border-radius: 100px;" />
                                                        </router-link>
                                                    </div>
                                                    <div class="col-md-8">
                                                        <h4 class="text-md-left mt-md-0"
                                                            style="font-size: 15px;margin-top: 1rem;">
                                                            <router-link :to="{
                                                                name: 'doctor-profile',
                                                                params: { name: item.name },
                                                            }">
                                                                {{ item.first_name }} {{ item.middle_name }}
                                                                {{ item.last_name }}
                                                            </router-link>
                                                            <img v-if="item.verification_status"
                                                                style="height: 15px; background: none;"
                                                                src="@/assets/img/verifydoc.png" alt="User Image" />
                                                        </h4>
                                                        <p class="text-md-left" style="font-size: 13px;">
                                                            {{ item.healthcare_practitioner_category }}
                                                        </p>
                                                        <p class="doc-department text-md-left">
                                                            {{ get_doctor_qualification(item.qualification) }}
                                                        </p>
                                                        <div class="text-md-left" v-if="item.average_ranking">
                                                            <star-rating v-model="item.average_ranking" :star-size="13"
                                                                :max-rating="5" :show-rating="false"
                                                                :read-only="disabledEdit"></star-rating>
                                                            <span class="d-inline-block average-rating">
                                                                ({{ item.rating }})
                                                            </span>
                                                        </div>
                                                        <p class="text-md-left" style="font-size: small; color: grey;">
                                                            <i class="fas fa-map-marker-alt"></i>
                                                            {{ item.city }}, {{ item.state }}
                                                        </p>
                                                        <div class="clinic-services text-md-left">
                                                            <div class="service-container"
                                                                v-for="(speciality, index) in item.practitioner_speciality"
                                                                :key="index">
                                                                <span style="background-color: #F5F5F5;">{{
                                                                    speciality.practitioner_speciality }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="doc-info-left">
                                                    <div class="clini-infos">
                                                        <ul>
                                                            <li v-if="item.feedback_count">
                                                                <i class="far fa-comment"></i>
                                                                {{ item.feedback_count }} Feedback
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <router-link :to="{
                                                            name: 'doctor-profile',
                                                            params: { name: item.name },
                                                        }">
                                                            <button class="book_appointment btn btn-primary mt-1">
                                                                Profile
                                                            </button>
                                                        </router-link>
                                                    </div>
                                                    <div class="col-md-7">
                                                        <div class="d-md-flex">
                                                            <button v-if="item.booking_appoinment === 0"
                                                                class="btn btn-secondary mt-1"
                                                                style="background-color:#D3D3D3;color:white;border:none;">No
                                                                Schedule</button>
                                                            <button v-else-if="item.booking_appoinment === 1"
                                                                class="book_appointment btn btn-primary mt-1"
                                                                style="color:white;border:none;"
                                                                @click="check_book_appointment(item.name)">Book
                                                                Appointment</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center" v-if="doctors.length > 12">
                                        <div>
                                            <h5 class="mt-1" style="color: #8d8c8c;">Total Doctors : {{ totalCount }}</h5>
                                        </div>
                                    </div>
                                    <!-- pagination start -->
                                    <div id="pagination" class="ml-3" v-if="doctors.length > 12">
                                        <ul class="pagination justify-content-center">
                                            <!-- "Previous" Button -->
                                            <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                                                <a href="#" class="page-link" aria-label="Previous"
                                                    @click.prevent="updateInvestigationCount(current - 1)">
                                                    Previous
                                                </a>
                                            </li>
                                            <!-- Pagination Links (Display 5 at a time) -->
                                            <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                                                'page-item',
                                                current === page_index ? 'active' : ''
                                            ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                                                <a href="#" class="page-link"
                                                    @click.prevent="updateInvestigationCount(page_index)">
                                                    {{ page_index }}
                                                </a>
                                            </li>
                                            <!-- "Next" Button -->
                                            <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                                                ">
                                                <a href="#" class="page-link" aria-label="Next"
                                                    @click.prevent="updateInvestigationCount(current + 1)">
                                                    Next
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <!-- pagination end -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <layout-footer v-if="categories.length > 0 && doctors.length > 0"></layout-footer>
        </div>
    </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import CommonApi from "../../services/CommonApi";
import StarRating from "vue-star-rating";
import { mapState } from "vuex";
import axios from "axios";

export default {
    components: { StarRating, VueGoogleAutocomplete },
    props: ["hospital"],
    data() {
        return {
            current: 1,
            paginate: 12,
            paginate_total: 0,
            showspinner: true,
            lattitude: "",
            longitude: "",
            search_by: "state_city",
            states: [],
            selected_state: "",
            cities: [],
            selected_city: "",
            selected_complaint: "",
            categories: [],
            selected_category: "",
            doctors: [],
            activeCatitem: "",
            hideactiveSubCat: true,
            totalCount: 0,
            search_params: {
                state: "",
                city: "",
                longitude: "",
                lattitude: "",
                complaints: "",
                healthcare_sub_category: "",
                gender: "",
                practitioner_speciality: "",
                healthcare_category: "",
            },

            SubCatslickOptions: {
                slidesToShow: 6,
                // ... your other settings
            },

            catslickOptions: {
                slidesToShow: 5,
                infinite: false,
                rows: 3,
                dots: false,
                arrows: true,
                swipeToSlide: true,
                autoplay: true,
                autoplaySpeed: 2000,
                pauseOnHover: true,

                variableWidth: false,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                ],
            },
            sub_categories: [],
            selected_sub_category: "",
            activeSubCat: "",
            selected_gender: "",
            gender: ["Male", "Female"],
            selected_speciality: "",
            speciality: [],
            SubCatslickOptions: {
                slidesToShow: 7,
                infinite: false,
                dots: false,
                arrows: true,
                swipeToSlide: true,
                variableWidth: false,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    },
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                ],
            },
            showDescription: {},
        };
    },
    // components: {
    //   VueGoogleAutocomplete,
    // },
    watch: {
        selected_state: function () {
            this.search_params.lattitude = "";
            this.search_params.longitude = "";
            this.search_params.limit_start = 0;
            this.get_doctors(false);
        },
        selected_city: function () {
            this.search_params.lattitude = "";
            this.search_params.longitude = "";
            this.search_params.limit_start = 0;
            this.get_doctors(false);

        },
        selected_category: function () {
            this.search_params.limit_start = 0;
            this.get_doctors(false);

        },
        activeSubCat: function () {
            this.search_params.limit_start = 0;
            this.get_doctors(false);

        },
        selected_gender: function () {
            this.search_params.limit_start = 0;
            this.get_doctors(false);
        },
        selected_speciality: function () {
            this.search_params.limit_start = 0;
            this.get_doctors(false);
        },
    },
    mounted() {
        this.get_practitioner_profile();
        this.get_states();
        this.getCurrentLocation();
        this.get_complaints();
        this.get_speciality();
        const autocomplete = new google.maps.places.Autocomplete(
            this.$refs["autocomplete"]
        );
        var self = this;
        autocomplete.addListener("place_changed", function () {
            var place = autocomplete.getPlace();
            var latitude = place.geometry.location.lat();
            var longitude = place.geometry.location.lng();
            self.search_params.lattitude = latitude;
            self.search_params.longitude = longitude;
            self.get_doctors(false);
        });
        if ($(".pharmacy-home-slider .swiper-container").length > 0) {
            var swiper = new Swiper(".pharmacy-home-slider .swiper-container", {
                loop: true,
                speed: 1000,
                pagination: {
                    el: ".pharmacy-home-slider .swiper-pagination",
                    dynamicBullets: true,
                    clickable: true,
                },
                navigation: {
                    nextEl: ".pharmacy-home-slider .swiper-button-next",
                    prevEl: ".pharmacy-home-slider .swiper-button-prev",
                },
            });
        }
    },
    computed: {
        ...mapState({
            user_id: (state) => state.user.user_id,
            user_type: (state) => state.user.user_type,
        }),
        currentpath() {
            return this.$route.name;
        },
    },
    methods: {

        toggleDescription(subCategoryName) {
            // Initialize showDescription if it doesn't exist
            if (!this.showDescription.hasOwnProperty(subCategoryName)) {
                this.$set(this.showDescription, subCategoryName, true); // Set to true to initially show description
            } else {
                // Toggle the visibility
                this.showDescription[subCategoryName] = !this.showDescription[subCategoryName];
            }
        },

        initMap: function () {
            alert("ok");
        },

        showDescription(index) {
            this.hoveredIndex = index;
        },
        hideDescription() {
            this.hoveredIndex = null;
        },

        //pagination start
        updateInvestigationCount(i) {
            this.current = i;
            document.getElementById("doctors_container").scrollIntoView();
        },

        setPaginate(i) {
            if (this.current == 1) {
                return i < this.paginate;
            } else {
                return (
                    i >= this.paginate * (this.current - 1) &&
                    i < this.current * this.paginate
                );
            }
        },
        //pagination end

        onLocationEmpty() {
            if (document.getElementById("map").value === "") {
                this.search_params.lattitude = "";
                this.search_params.longitude = "";
                this.get_doctors(false);
            }
        },

        async check_book_appointment(id) {
            this.$swal({
                text: "Checking Schedule...",
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            const data = new URLSearchParams();
            data.append("practitioner", id);
            await CommonApi.get_data(
                "sahaj.appointment.check_practitioner_schedule",
                data
            ).then((res) => {
                if (res && res.status_code === 200) {
                    this.$swal.close();
                    this.$router.push({
                        name: "booking",
                        params: { name: id },
                    });
                } else {
                    this.$swal.close();
                    this.$swal.fire({
                        icon: "error",
                        title: "Error",
                        text: res.message,
                        showConfirmButton: true,
                    });
                }
            });
        },

        /* Add Doctor As Favourite  */
        async add_favourite_Doctor(doctor) {
            this.$swal({
                text: "Adding Doctor As Favourite",
                showConfirmButton: false,
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                },
            });
            let data = {
                practitioner: doctor,
                patient: this.user_id,
            };
            await CommonApi.post_data(
                "sahaj.finalapi.add_validate_patient_doctors_list",
                data
            ).then((res) => {
                this.add_favourite_Doctor_again(doctor);
            });
        },

        /* Add Doctor As Favourite  */
        async add_favourite_Doctor_again(doctor) {
            let data = {
                practitioner: doctor,
                patient: this.user_id,
            };
            await CommonApi.post_data("sahaj.finalapi.favorite_doctor", data).then(
                (res) => {
                    if (res && res.status_code === 200) {
                        this.$swal.fire({
                            icon: "success",
                            title: "Success",
                            text: res.message,
                            showConfirmButton: true,
                        });
                    }else{
                        this.$swal.fire({
                            icon: "warning",
                            title: "Warning",
                            text: res.message,
                            showConfirmButton: true,
                        });
                    }
                }
            );
        },

        get_doctor_qualification(qualification) {
            var qualification_string = [];
            qualification.map((data) => {
                qualification_string.push(data.qualification);
            });
            return qualification_string.join(" , ");
        },

        async get_states() {
            await CommonApi.get_data("sahaj.finalapi.get_states").then((res) => {
                this.states = res.message;
            });
        },
        async get_cities() {
            this.selected_city = "";
            const params = new URLSearchParams();
            params.append("state", this.selected_state);
            await CommonApi.get_data("sahaj.finalapi.get_city", params).then(
                (res) => {
                    this.cities = res.message;
                }
            );
        },
        set_search_by(search) {
            this.search_by = search;
        },
        searchPath() {
            this.$router.push("/doctor/search");
        },
        getCurrentLocation() {
            if (navigator.geolocation) {
                var self = this;
                navigator.geolocation.getCurrentPosition(function (p) {
                    var LatLng = new google.maps.LatLng(
                        p.coords.latitude,
                        p.coords.longitude
                    );

                    var geocoder = (geocoder = new google.maps.Geocoder());
                    geocoder.geocode({ latLng: LatLng }, function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK) {
                            if (results[1]) {
                                document.getElementById("map").value =
                                    results[1].formatted_address;
                            }
                        }
                    });
                });
            } else {
                alert("Geo Location feature is not supported in this browser.");
            }
        },

        async get_complaints() {
            await CommonApi.get_data("sahaj.finalapi.get_complaints").then((res) => {
                if (res.status_code == 200) {
                    // this.selected_complaint = res.data[0].complaints;
                    this.get_categories();
                }
            });
        },

        async get_speciality() {
            await CommonApi.get_data("sahaj.api.get_speciality_list").then((res) => {
                if (res.status_code == 200) {
                    this.speciality = res.data;
                }
            });
        },

        next() {
            this.$refs.slick.next();
        },
        prev() {
            this.$refs.slick.prev();
        },
        reInit() {
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
        loadImg(imgPath) {
            return images("./" + imgPath);
        },
        loadDocImg(imgPath) {
            return "https://develop-physio.kneexpert.in" + imgPath;
        },
        activeCatImage(id, category) {
            this.activeCatitem = id;
            this.selected_category = category;
            this.get_sub_categories();
        },

        async get_categories() {
            // Create a parameter object with the selected complaint and hospital prop
            let param = {
                complaints_treatment_offered: this.selected_complaint,
                hospital: this.hospital, // Assuming 'hospital' is a prop in your component
            };

            // Convert the parameter object into a query string format
            param = new URLSearchParams(param).toString();

            // Make an API call to fetch healthcare categories based on the parameters
            await CommonApi.get_data(
                "sahaj.finalapi.get_healthcare_categories_hospital",
                param
            ).then((res) => {
                this.showspinner = false;
                // If the API call is successful, update the categories data in the component
                if (res.status_code == 200) {
                    this.categories = res.data;
                }
            });
        },

        activeSubImage(category) {
            this.activeSubCat = category;
            this.hideactiveSubCat = false;
        },

        async get_sub_categories() {
            this.activeSubCat = "";
            let param = {
                healthcare_category: this.selected_category,
                complaints_treatment_offered: this.selected_complaint,
            };
            param = new URLSearchParams(param);
            await CommonApi.get_data(
                "sahaj.finalapi.get_healthcare_sub_categories",
                param
            ).then((res) => {
                if (res.status_code == 200) {
                    this.sub_categories = res.data;
                }
            });
        },


        async get_practitioner_profile() {
            var domain = window.location.hostname;

            const formdata = {
                domain: window.location.hostname,
            };


            await axios
                .get(
                    "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
                    window.location.hostname
                )
                .then((res) => {
                    this.showspinner = false;
                    if (res.data.status_code == 200) {

                    }
                    if (res.data.status_code == 404) {
                        if (window.location.hostname == "physio.sahajhelp.com") {            } 
                        else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {

             }  else if (window.location.hostname.startsWith("192.168")) {
            }
            else if (window.location.hostname == "iitb.smartyhealthcare.in") { } 
            else {
                            window.location.href = String("https://physio.kneexpert.in");
                        }
                    }

                    this.$swal.close();
                });
        },


        async get_doctors(value) {
            this.$swal({
                showConfirmButton: false,
                allowOutsideClick: false,
                customClass: "homepage-swal",
                didOpen: () => {
                    this.$swal.showLoading();
                },
                didClose: () => {
                    if (value) {
                        document.getElementById("doctors_container").scrollIntoView();
                    }
                },
            });
            if (this.hospital) {
                this.search_params.hospital = this.hospital;
            }
            this.search_params.state = this.selected_state;
            this.search_params.city = this.selected_city;
            this.search_params.complaints = this.selected_complaint;

            this.search_params.healthcare_category = this.selected_category;
            this.search_params.healthcare_sub_category = this.activeSubCat;
            this.search_params.gender = this.selected_gender;
            if (!this.selected_state) {
                delete this.search_params.state;
                delete this.search_params.city;
            }
            if (!this.selected_city) {
                delete this.search_params.city;
            }
            this.search_params.practitioner_speciality = this.selected_speciality;
            let search = new URLSearchParams(this.search_params);
            await CommonApi.get_data(
                "sahaj.finalapi.get_doctor_list_v2",
                search
            ).then((res) => {
                this.totalCount = res.data.length;
                this.doctors = res.data.slice(0, -1);
                this.paginate_total = Math.ceil(
                    this.doctors.length / this.paginate
                );
                this.$swal.close();
            });
        },
    },
};
</script>

<style scoped>

.fa-heart {
  color: red;
}
.book_appointment:hover {
    background-color: mediumseagreen;
}

.view-pro-btn,
.apt-btn {
    width: 250px !important;
    margin-top: 10px !important;
    height: 45px;
}

.clinic-booking a.apt-btn.knee {
    padding: 2px;
}

section.section-container {
    background: #f9f9f9;
}

.section-search {
    max-width: 1500px;
}

.content {
    min-height: 20px;
    padding: 30px 0 0;
}

.book-appointment {
    cursor: pointer;
}

.slick-slide div {
    margin-bottom: 30px !important;
}

.slick-slider {
    margin-top: 20px;
    /* Adjust this value based on how much space you want */
}

.section-header h2 {
    margin-top: 10px;
    margin-bottom: 10px;
    /* Adjust this value based on the desired gap */
}

.slick-list {
    margin: 0 -10px;
    /* Negative margins counteract card margins for edge cards */
}

.card {
    border: 1px solid #ccc;
    padding: 10px;
    text-align: center;
    margin: 0 10px;
    box-sizing: border-box;
}

.card-title {
    font-size: 16px;
    margin-bottom: 10px;
}

.card-image img {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    margin-bottom: 10px;
}

.card-description {
    font-size: 12px;
}

.clinic-services {
    color: #272b41;
}

.service-container {
    box-sizing: border-box;
    /* Two items per row */
    margin: 1px;
    display: inline-block;

}

.clinic-services span {
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 10px;
    padding: 3px 3px;
}


@media screen and (max-width: 767px) {

    .clinic-details {
        margin-top: 12px;
    }
}

@media screen and (min-width: 1024px) {

    .form-group {
        margin-left: auto;
        /* Center the form group horizontally */
        margin-right: auto;
        width: 430px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/SearchHospitalDoctors.vue